<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3> {{ label.get('break_preferences') }}</h3>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('preference') }}</label>
          </div>
          <div class="action-buttons" v-if="saveChangesEnabled">
            <button
                class="update-btn cancel"
                type="button"
                @click="cancel"
            >
              <i class="atto atto-close-btn"/>
              {{ label.get('cancel') }}
            </button>
            <button
                class="update-btn save-changes"
                @click="saveChanges"
                type="button"
            >
              <i class="atto atto-selected-tick"/>
              {{ label.get('save_changes') }}
            </button>
          </div>
        </div>
        <div class="break-preferences">
          <div class="field-wrap">
            <div class="label-wrapper">
              <label class="label">
                {{ label.get('break_preferences_break_rule') }}
              </label>
              <p>
                {{ label.get('break_preferences_team_can_start_end_breaks_description') }}
              </p>
            </div>
            <select-dropdown-component
                :value="breakRule"
                placeholder="Select method"
                :options="breakOptions"
                @onOptionSelected="onBreakChanged"
            />
          </div>

          <div class="field-wrap" v-if="breakRule !== 3 && breakRule !== 4">
            <div class="label-wrapper">
              <label class="label">
                {{ label.get('break_preferences_type') }}
              </label>
              <p>
                {{ label.get('break_preferences_type_description') }}
              </p>
            </div>
            <select-dropdown-component
                :value="paidRule"
                placeholder="Select method"
                :options="paidOptions"
                @onOptionSelected="onPaidRulesChanged"
            />
          </div>

          <div
              v-if="breakRule !== 3 && breakRule !== 4"
              class="field-wrap"
              :class="{'has-error': breakError, 'disabled': breakRule === 1 }"
          >
            <div class="label-wrapper">
              <label class="label">
                {{ label.get('break_preferences_length') }}
              </label>
              <span
                  v-if="breakError"
                  class="error-message"
              >
                  {{ label.get('break_preferences_length_one_min_description') }}
                </span>
              <p>
                {{ label.get('break_preferences_length_description') }}
              </p>
            </div>

            <time-picker-component
                v-model="breakLength"
                class="weekly-hours"
                :format24h="true"
                :required="true"
            />
          </div>
        </div>
      </div>
      <break-codes-component v-if="breakRule === 3"/>
      <advanced-break-type-component v-if="breakRule === 4" />
    </div>
  </div>
</template>

<script>

import SelectDropdownComponent from '../../../shared/components/SelectDropdownComponent';
import TimePickerComponent from '../../../features/timesheets/shared/components/TimePickerComponent';
import BreakPreferencesService from './services/BreakPreferencesService';
import BreakCodesComponent from "./components/BreakCodesComponent";
import AdvancedBreakTypeComponent from "./components/AdvancedBreakTypeComponent";

export default {
  name: "BreakPreferenceComponent",
  components: {
    AdvancedBreakTypeComponent,
    BreakCodesComponent,
    SelectDropdownComponent,
    TimePickerComponent
  },
  data() {
    return {
      breakError: false,
      saveChangesEnabled: false,
      paidRule: this.$store.state.companySettings.break_type,
      breakLength: this.$store.state.companySettings.break_length,
      breakRule: this.$store.state.companySettings.break_rule,
      breakOptions: this.getBreakRules(),
      paidOptions: this.getBreakTypes()
    }
  },
  watch: {
    breakLength(newVal, oldVal) {
      if(newVal !== this.$store.state.companySettings.break_length) {
        this.saveChangesEnabled = true;
        this.disabledSubmitButton = false;
      } else {
        this.saveChangesEnabled = false;
        this.disabledSubmitButton = true;
      }
    },
    paidRule(newVal, oldVal) {
      if(newVal !== this.$store.state.companySettings.break_type) {
        this.saveChangesEnabled = true;
        this.disabledSubmitButton = false;
      } else {
        this.saveChangesEnabled = false;
        this.disabledSubmitButton = true;
      }
    },
    breakRule(newVal, oldVal) {
      if(newVal !== this.$store.state.companySettings.break_rule) {
        this.saveChangesEnabled = true;
        this.disabledSubmitButton = false;
      } else {
        this.saveChangesEnabled = false;
        this.disabledSubmitButton = true;
      }
    }
  },
  methods: {
    getBreakCodes() {
      BreakPreferencesService.getBreakCodes().then((response) => {
        this.$store.state.breakCodes = response;
      }).catch(() => {
        console.log(this.label.get('error_loading_break_codes'));
      });
    },
    getTypeLabel(type) {
      const typeObj = this.getBreakTypes().find(x => x.value === type);
      if (typeObj) {
        return typeObj.label;
      }
      return 'Unknown';
    },
    onBreakChanged(option) {
      this.breakRule = option.value;
      this.saveChangesEnabled = true;
    },
    onPaidRulesChanged(option) {
      this.paidRule = option.value;
      this.saveChangesEnabled = true;
    },
    getBreakRules() {
      return BreakPreferencesService.getBreakRules(this.label);
    },
    getBreakTypes() {
      return BreakPreferencesService.getBreakTypes(this.label);
    },
    saveChanges() {
      if (this.breakLength === '00:00:00') {
        this.breakError = true;
        return false;
      }

      if (this.breakLength !== '') {
        this.breakLength = this.$moment(this.breakLength, 'HH:mm:ss').format("HH:mm");
      }
      this.$store.commit('showLoading');
      this.$store.state.companySettings.break_type = this.paidRule;
      this.$store.state.companySettings.break_length = this.breakLength;
      this.$store.state.companySettings.break_rule = this.breakRule;
      this.$store.state.companySettings.break_code = this.breakCode;
      this.breakError = false;
      BreakPreferencesService.updateCompanySettings(this.$store.state.companySettings).then((result) => {
        this.$store.commit('hideLoading');
        this.saveChangesEnabled = false;
        this.$awn.success(result.data.message);
      }).catch((error) => {
        this.$store.commit('hideLoading');
        console.log(error);
      })
    },
    cancel() {
      this.paidRule = this.$store.state.companySettings.break_type;
      this.breakLength = this.$store.state.companySettings.break_length;
      this.breakRule = this.$store.state.companySettings.break_rule;
      this.saveChangesEnabled = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.break-preferences {
  display: flex;
  width: 100%;
  flex-flow: column;

  .field-wrap {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 40px;
    border-bottom: 1px solid $atto-light-grey;

    .label-wrapper {
      width: 60%;

      label {
        font: $roboto-regular 0.9375rem/1.75rem $roboto-font;
        margin-bottom: 4px;
        color: $atto-font-color;
      }

      p {
        font: $roboto-regular 0.875rem/1.25rem $roboto-font;
        color: #666666;
        margin: 0;
      }
    }

    .atto-select {
      width: 184px;
    }

    &.disabled {
      opacity: 0.25;
      pointer-events: none;
    }
  }
}
</style>